import styled from "styled-components";


export const ButtonDownload = styled.div`
  display: flex;
  cursor: pointer;
  background-color: transparent;
  padding:  10px 16px;
  gap: 8px;
  color: #2F5BFF;
  font-size: 14px;
`